// Zod without compiled parsers, first of every module the app loads (`main.tsx`).
//
// THE PAGE REFUSES `eval` (its content security policy, `scripts/vite/
// security-headers.ts`), and Zod's fast
// path compiles a parser with `new Function` after asking whether it may: the
// question is itself an attempt, which the browser refuses and reports as a
// policy violation on every page load. Told up front, Zod never asks, and
// parses the way it does wherever compiling is refused. Imported for its
// effect, before anything that defines or reads a schema.

import { z } from 'zod';

z.config({ jitless: true });
